import { combineEpics, type Epic, ofType } from 'redux-observable';
import { bufferTime, filter, map, mergeMap } from 'rxjs';
import { type Action } from '@reduxjs/toolkit';
import { fetchSports } from '@/slices/sports/actions';
import { startPendingCall, stopPendingCall } from '../actions';

const trimSuffix = (type: string) => type.replace(/\/(succeeded|failed)$/, '');

// This is a list of action types that will trigger the global loader
// It should look like this:
// const GLOBAL_LOADER_ACTIONS = [fetchDemo as Action] as const;
const GLOBAL_LOADER_ACTIONS = [fetchSports as Action] as const;

const startPendingCallEpic: Epic = (action$) =>
  action$.pipe(
    ofType(...GLOBAL_LOADER_ACTIONS),
    map(({ type }) => startPendingCall(type)),
  );

const stopPendingCallEpic: Epic = (action$) =>
  action$.pipe(
    filter(
      ({ type }: Action) =>
        type.includes('succeeded') || type.includes('failed'),
    ),
    bufferTime(0),
    mergeMap((actions) =>
      actions.map(({ type }) => stopPendingCall(trimSuffix(type))),
    ),
  );

export default combineEpics(startPendingCallEpic, stopPendingCallEpic);
